import { datadogRum } from '@datadog/browser-rum-slim';
import { LDObserve } from '@launchdarkly/observability';

import { nrAddPageAction } from './internal/newRelicRum';

function isPerformanceNavigationTimingEntry(
  performanceEntry: PerformanceEntry,
): performanceEntry is PerformanceNavigationTiming {
  return performanceEntry.entryType === 'navigation';
}

export function trackPageLoadCustomMetrics() {
  const observer = new PerformanceObserver((list: PerformanceObserverEntryList) => {
    const navigationEntry = list.getEntries()[0];

    if (navigationEntry && isPerformanceNavigationTimingEntry(navigationEntry)) {
      // Add the html_request_time custom metric: This accounts for the time
      // from when the browser begins the request until the final byte of the
      // response is received. It does not include any potential unloading time
      // for a previous page, time the request might have been queued, time
      // spent parsing the HTML response, etc.
      //
      // See https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming
      const htmlRequestTime = navigationEntry.responseEnd - navigationEntry.requestStart;
      datadogRum.addTiming('html_request_time', htmlRequestTime);
      // New Relic has no `addTiming` equivalent; record as a PageAction instead.
      nrAddPageAction('html_request_time', {
        duration: htmlRequestTime,
        'url.path': window.location.pathname,
      });
      LDObserve.recordHistogram({
        name: 'page_load.html_request_time',
        value: htmlRequestTime,
        attributes: {
          'url.path': window.location.pathname,
        },
      });
      observer.disconnect();
    }
  });

  observer.observe({ buffered: true, type: 'navigation' });
}
